import { useState } from "react";

export const useModalData = () => {

    const [show, setShow] = useState<any>({ value: false });

    const handleClose = () => setShow({ value: false })

    const handleShow = (dataObj: any = {}) => setShow({
        value: true, 
        ...dataObj
    });

    return [show, handleShow, handleClose];
};
